import { NgModule } from "@angular/core";
import { OnlyIntegerDirective } from "./integer.directive";
import { MinNumberDirective } from "./minNumber.directive";
import { MaxNumberDirective } from "./maxNumber.directive";
import { FocusDirective } from "./focus.directive";

@NgModule({
  declarations: [
    OnlyIntegerDirective,
    MinNumberDirective,
    MaxNumberDirective,
    FocusDirective
  ],
  exports: [
    OnlyIntegerDirective,
    MinNumberDirective,
    MaxNumberDirective,
    FocusDirective
  ]
})

export class InputHelperModule {
}
